import { useCallback, useEffect } from 'react';
import { useFormAugmentedContext } from './FormAugmentedContext.tsx';
import { type InvalidFormEvent } from './InvalidFormSubject.tsx';

/**
 * Hook che permette di sottoscriversi all'evento del Submit con i risultati
 * di validazione.
 * Ritorna un evento dedicato in caso di Success ("valid") oppure di Errore ("invalid"")
 */
export function useInvalidFormEvent(
  callback: (event: InvalidFormEvent) => void,
  deps?: string[],
) {
  const augmented = useFormAugmentedContext();

  const memoizedCallback = useCallback(callback, deps ?? []);

  useEffect(() => {
    const subscription = augmented.invalidSubject.subscribe(memoizedCallback);
    return () => subscription.unsubscribe();
  }, [augmented.invalidSubject, memoizedCallback]);
}
